import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _getEditorUrlsRequest = {};
var _getEditorUrlsResponse = {};
function resolveWixEditorurlsV2EditorUrlsApiUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/editor-urls',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/editor-urls',
                destPath: '/v2/editor-urls',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Retrieves a site's Editor URLs. */
export function getEditorUrls(payload) {
    var _a = serializer(_getEditorUrlsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getEditorUrlsResponse, {}).fromJSON;
    function __getEditorUrls(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.editorurls.v2.editor_urls',
            method: 'GET',
            methodFqn: 'wix.editorurls.v2.EditorUrlsApi.GetEditorUrls',
            url: resolveWixEditorurlsV2EditorUrlsApiUrl({
                protoPath: '/v2/editor-urls',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getEditorUrls.fromReq = fromReq;
    __getEditorUrls.__isAmbassador = true;
    return __getEditorUrls;
}
//# sourceMappingURL=http.impl.js.map